import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TrainSchedule } from '../models/train-schedule';
import { TimetableEntry } from '../models/timetable-entry';

@Injectable({
  providedIn: 'root'
})
export class TrainScheduleDataService {

  constructor(
    private http: HttpClient,
    @Inject('TimeZoneFactory') private timeZoneFactory: any,
  ) { }


  getTrainSchedule = (projectId: number, date: Date) :  Observable<TrainSchedule[]> => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
    .set('date', this.timeZoneFactory.format(date));
 
    return this.http.get<TrainSchedule[]>(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.planning}`, {
      params
    });
  }

  saveTrainScheduleEntry = (projectId: number, entry: TrainSchedule) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.scheduleEntries}?projectId=${projectId}`, entry ).toPromise();
  }

  updateTrainScheduleEntry = (projectId: number, entry: TrainSchedule) => {
    console.log(entry)
    return this.http.put(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.scheduleEntries}/${entry.id}?projectId=${projectId}`, entry ).toPromise();
  }

  deleteTrainScheduleEntry = (projectId: number, entry: TrainSchedule) => {
    return this.http.delete(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.scheduleEntries}/${entry.id}?projectId=${projectId}`).toPromise();
  }

  getTimetable = (projectId: number) :  Observable<TimetableEntry[]> => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
 
    return this.http.get<TimetableEntry[]>(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.timetable}`, {
      params
    });
  }

  saveTimetableEntry = (projectId: number, entry: TimetableEntry) => {
    entry = {
      ...entry,
      projectId: projectId
    }
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.timetableEntry}?projectId=${projectId}`, entry ).toPromise();
  }

  updateTimetableEntry = (projectId: number, entry: TimetableEntry) => {
    entry = {
      ...entry,
      projectId: projectId
    }
    return this.http.put(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.timetableEntry}/${entry.id}?projectId=${projectId}`, entry ).toPromise();
  }

  deleteTimetableEntry = (projectId: number, entry: TimetableEntry) => {
    return this.http.delete(`${environment.api.baseUrl}/${environment.api.endpoints.trainSchedule.timetableEntry}/${entry.id}?projectId=${projectId}`).toPromise();
  }
}
